<div class="container-space-between">
  <app-page-title
    [title]="translations.title"
    [backText]="translations.titleBackText"
    [goBackRoute]="routingEnum.INBOX"
  ></app-page-title>
</div>
<div [formGroup]="formGroup">
  @if (isLoading()) {
    <app-loader></app-loader>
  } @else if (configs.length) {
    @if (existingRecordsConfig().length) {
      <h2>
        <ng-container i18n="@@shared.existing">Existing</ng-container>
        <mat-icon class="help-icon" [tp]="translations.existingTp" tpPlacement="right">
          help
        </mat-icon>
      </h2>

      @for (config of existingRecordsConfig(); let idx = $index; track idx) {
        <h3>
          {{ config.title }}
        </h3>
        <app-trasfer-or-map-form
          [shareRecordType]="config.shareRecordType"
          [additionalProps]="config.additionalProps"
          [sharedData]="config.sharedData"
          [localRecords]="config.localRecords"
          [inputSelectPlaceholder]="config.inputSelectPlaceholder"
          [existingMappings]="config.existingMappings()"
          [isViewButtonDisabled]="config.isViewButtonDisabled"
          (newRecordCreated)="config.reloadFn()"
          [inboundShare]="inboundShare"
          [isTransferButtonDisabled]="
            config.isTransferButtonDisabled() && !!existingRecordsConfig().length
          "
          [isTransferButtonVisible]="config.isTransferButtonVisible()"
          (inboundMappingAdded)="inboundMappingAdded($event)"
          (inboundMappingRemoved)="inboundMappingRemoved($event)"
          [formGroup]="formGroup"
        ></app-trasfer-or-map-form>
      }
    }

    @if (newRecordsConfig().length) {
      <h2>
        <ng-container i18n="@@transfer-or-map-data.newrecords">New records</ng-container>
        <mat-icon class="help-icon" [tp]="translations.newRecordsTp" tpPlacement="right">
          help
        </mat-icon>
      </h2>
      @for (config of newRecordsConfig(); let idx = $index; track idx) {
        <h3
          [ngClass]="{
            disabled: config.isTransferButtonDisabled(),
          }"
        >
          {{ config.title }}
          @if (config.isTransferButtonDisabled()) {
            <mat-icon>lock</mat-icon>
            <mat-icon
              class="help-icon"
              [tp]="config.unmappedDependenciesTooltip"
              tpPlacement="right"
            >
              help
            </mat-icon>
          }
        </h3>
        <app-trasfer-or-map-form
          [shareRecordType]="config.shareRecordType"
          [additionalProps]="config.additionalProps"
          [sharedData]="config.sharedData"
          [localRecords]="config.localRecords"
          [inputSelectPlaceholder]="config.inputSelectPlaceholder"
          [existingMappings]="config.existingMappings()"
          [isViewButtonDisabled]="config.isViewButtonDisabled"
          [isTransferButtonDisabled]="config.isTransferButtonDisabled()"
          [isTransferButtonVisible]="config.isTransferButtonVisible()"
          (newRecordCreated)="config.reloadFn()"
          [inboundShare]="inboundShare"
          (inboundMappingAdded)="inboundMappingAdded($event)"
          (inboundMappingRemoved)="inboundMappingRemoved($event)"
          [formGroup]="formGroup"
        ></app-trasfer-or-map-form>
      }
    }

    @if (mappedRecordsConfig().length) {
      <h2 i18n="@@transfer-or-map-data.mappedrecords">Mapped records</h2>
      @for (config of mappedRecordsConfig(); let idx = $index; track idx) {
        <h3>{{ config.title }}</h3>
        <app-trasfer-or-map-form
          [shareRecordType]="config.shareRecordType"
          [additionalProps]="config.additionalProps"
          [sharedData]="config.sharedData"
          [localRecords]="config.localRecords"
          [inputSelectPlaceholder]="config.inputSelectPlaceholder"
          [existingMappings]="config.existingMappings()"
          [isViewButtonDisabled]="config.isViewButtonDisabled"
          (newRecordCreated)="config.reloadFn()"
          [inboundShare]="inboundShare"
          (inboundMappingAdded)="inboundMappingAdded($event)"
          (inboundMappingRemoved)="inboundMappingRemoved($event)"
          [formGroup]="formGroup"
        ></app-trasfer-or-map-form>
      }
    }
  }
</div>
